export const isLoggedIn = () => {
  try {
    const authData = localStorage.getItem('auth');
    if (!authData) return false;

    const parsed = JSON.parse(authData);
    return Boolean(parsed?.state?.user);
  } catch (error) {
    return false;
  }
};

